import Tabs from "../tabs";
import { useSelector } from "react-redux";
import CircularLoader from "../../../../components/loaders/circularLoader";
import { Box, Dialog, DialogContent } from "@mui/material";
import { useState, useEffect } from "react";
import SnackbarMessage from "../../../../components/snackBar/snackBar";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import DomainAddOutlinedIcon from "@mui/icons-material/DomainAddOutlined";
import NameCardList from "../nameCardList";
import { DepartmentCreateForm } from "./departmentCreation";
import { qrDialogPaperSx, QrModalHeader } from "../../../qrCode/components/qrUi";

export default function DepartmentList() {
  const { departments, status, error } = useSelector((state) => state.general);

  const [search, setSearch] = useState("");
  const [createOpen, setCreateOpen] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    if (status === "failed") {
      setSnackbar({
        open: true,
        message: error,
        severity: "error",
      });
    }
  }, [status, error]);

  // Same filter as before
  const filteredDepartments = status !== "succeeded" ? [] : departments.filter((item) => item.department_name.toLowerCase().includes(search.toLowerCase()));

  return (
    <div>
      <Tabs onCreate={() => setCreateOpen(true)}>
        <Box>
          {/* Loader */}
          {status === "loading" && (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <CircularLoader color="success" />
            </Box>
          )}

          {/* Success */}
          {status === "succeeded" && (
            <NameCardList
              items={filteredDepartments}
              getName={(item) => item.department_name}
              getId={(item) => item.id}
              search={search}
              onSearchChange={(value) => {
                // no leading space (same rule as before)
                if (!value.startsWith(" ")) {
                  setSearch(value)
                }
              }}
              searchPlaceholder="Search Department"
              countIcon={<BusinessOutlinedIcon />}
              countLabel="department"
              watermark={<BusinessOutlinedIcon />}
            />
          )}
        </Box>
      </Tabs>

      {/* Create department popup */}
      <Dialog
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        fullWidth
        maxWidth="xs"
        PaperProps={{ sx: { ...qrDialogPaperSx, maxWidth: { sm: 460 } } }}
      >
        <QrModalHeader
          icon={<DomainAddOutlinedIcon />}
          title="Create Department"
          subtitle="Add a new department"
          onClose={() => setCreateOpen(false)}
        />
        <DialogContent sx={{ p: 0 }}>
          {/* remounts on each open, so the form starts empty */}
          {createOpen && (
            <DepartmentCreateForm
              embedded
              onCancel={() => setCreateOpen(false)}
              onSuccess={(message) => {
                setCreateOpen(false);
                setSnackbar({ open: true, message: message || "Department created", severity: "success" });
              }}
            />
          )}
        </DialogContent>
      </Dialog>

      <SnackbarMessage open={snackbar.open} message={snackbar.message} severity={snackbar.severity} onClose={() => setSnackbar(prev => ({ ...prev, open: false }))} />
    </div>
  );
}
